import { render, staticRenderFns } from "./PollItem.vue?vue&type=template&id=26c1244d&scoped=true"
import script from "./PollItem.vue?vue&type=script&lang=js"
export * from "./PollItem.vue?vue&type=script&lang=js"
import style0 from "./PollItem.vue?vue&type=style&index=0&id=26c1244d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c1244d",
  null
  
)

export default component.exports